export const formatPriceUptoK = (price: number) => {
    if (price >= 1000000000) {
        return `${Math.floor(price / 1000000000)}B`
    }
    if (price >= 1000000) {
        return `${Math.floor(price / 1000000)}M`
    }
    if (price >= 10000) {
        return `${Math.floor(price / 1000)}K`
    }
    return price.toString()
}